import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.6dqYnF',
    defaultMessage: 'Invoices',
  },
  invoiceInformation: {
    id: 'studio.yiVIXX',
    defaultMessage:
      'Invoices are currently only delivered via Email, but an invoice overiew on this page is being worked on.',
  },
});
